import React, { useState } from "react"
import _ from "../../utils/lodashUtils"
import "./CartPopup.scss"
import plates from "../../assets/images/plates.svg"
import hand from "../../assets/images/hand.svg"
import RightArrowBend from "./RightArrowBend"
import { Tooltip } from "antd"
import { ToastMessage, NOTIFICATION_TYPES } from "../Notification/Notifications"
import {
  CloseOutlined,
  ClockCircleOutlined,
  LikeFilled,
  DislikeFilled,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons"
import {
  FIREBASE_STATE_KEYS,
  FirebaseContext,
  FirebaseService,
} from "../../firebase"
import { SUGGESTION_STATES } from "../../constants/commons"
import {
  ADD_TO_MY_CART,
  SUGGEST_ITEM,
  ACCEPT_SUGGESTION,
  DELIVERY_MINIMUM,
  REJECTED_STATUS,
  ACCEPTED_STATUS,
  PENDING_STATUS,
  EMPTY_CART_TEXT,
  CHECKOUT_TEXT,
  READY_TO_CHECKOUT,
  PARTNER_SUGGESTED_YOU,
  YOU_SUGGESTED_MENU,
  MENU_SUGGESTION_DECLINED,
  MENU_SUGGESTION_ACCEPTED,
  WAITING_TO_CHECKOUT,
  UNDO,
  ADDED,
} from "../../constants/messages"
import { TextTag as Text, Button } from "../../atoms"
import {
  isPartnerAway,
  getGenderSpecificMessage,
  consolidateItemQuantityInCart,
} from "../../utils/helpers"
import { MenuItem } from "../MenuItem/MenuItem"

// each item in cart view
export const ItemRow = props => {
  const {
    item,
    item: { name, price, quantity, options },
    isPartner,
    removeItemFromCart,
    onAddToMyCart,
    partnerAway,
    mySuggestions,
    addSelectedItemOptions,
    partnerCart,
    user,
    partner,
    toggleAddToCartItem,
    itemLoading,
  } = props

  const { dateState, userState } = React.useContext(FirebaseContext)
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT
  )
  let userSuggestions = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )

  const acceptedRestaurantMenu = _.get(acceptedRestaurant, "menus", {})

  const itemInMySuggestions =
    _.get(mySuggestions, `${item.id}`) || _.get(partnerCart, `${item.id}`)

  const itemInPartnersCart =
    _.get(partnerCart, `cart`, []).filter(
      partnerCartItem => partnerCartItem.id === item.id
    ).length > 0
  const suggestText = itemInPartnersCart ? ADDED : SUGGEST_ITEM

  const getItemState = () => {
    /* returns state of item, i.e suggest, pending, accepted, rejected.
      if the item is not in suggestions it can be suggested.
      if the item is in suggestions and in partner's cart, it is treated as accepted
      if the item is in my suggestions with status accepted but not in partner's cart we identify it as rejected.
      (☝🏻 is a bug in current cart system where accepted but removed from cart items are still shown accepted in menu)
      else it is we return a label based on the suggestion's state.
    */
    let itemState
    if (itemInMySuggestions && itemInPartnersCart) {
      itemState = ACCEPTED_STATUS
    } else if (itemInMySuggestions) {
      if (
        mySuggestions[item.id][FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
        SUGGESTION_STATES.REJECTED
      ) {
        itemState = REJECTED_STATUS
      } else if (
        !itemInPartnersCart &&
        mySuggestions[item.id][FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
          SUGGESTION_STATES.ACCEPTED
      ) {
        itemState = REJECTED_STATUS
      } else {
        itemState = PENDING_STATUS
      }
    }
    return itemState
  }

  const onSuggestClick = async () => {
    const payload = {
      item,
      [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: SUGGESTION_STATES.PENDING,
    }
    // patch item to suggestions
    const path = `${user.uuid}/${[FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER]}`
    // Adding an item to suggestions list.
    userSuggestions[item.id] = payload

    const partnerCartNotificationPath = `${partner.uuid}/${FIREBASE_STATE_KEYS.CART_NOTIFICATION}`
    await FirebaseService.patch(
      {
        [path]: userSuggestions,
        [partnerCartNotificationPath]: {
          [FIREBASE_STATE_KEYS.INDICATOR]: true,
          [FIREBASE_STATE_KEYS.MESSAGE]: PARTNER_SUGGESTED_YOU(
            _.get(user, "display_name", "")
          ),
          [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
          [FIREBASE_STATE_KEYS.SHOULD_OPEN_CART]: true,
        },
      },
      FirebaseService.getDefaultPath()
    )
    // set notification indicator for self
    ToastMessage({
      type: NOTIFICATION_TYPES.INFO,
      message: YOU_SUGGESTED_MENU,
    })
  }
  const onRemoveItem = () => {
    removeItemFromCart(
      item,
      acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      item.item_key
    )
  }

  const handleClosePopup = () => {
    toggleAddToCartItem(false, {})
  }
  return (
    <li className="item-row">
      <div class="item-data-section">
        <Text
          textType="smallTextPrimary"
          className={props.isMyItem ? "item-name my-item" : "item-name"}
          onClick={() => {
            let itemSelected = {}
            if (props.isMyItem) {
              Object.values(acceptedRestaurantMenu).forEach(partialMenu => {
                partialMenu.children &&
                  partialMenu.children.forEach(menuItem => {
                    if (menuItem.id === item.id) {
                      itemSelected = menuItem
                    }
                  })
              })
              const itemOptionList = {}
              const currentSelectedItem = {}
              if (item.options) {
                item.options.forEach(async optionList => {
                  const options = []
                  _.get(optionList, "options", []).forEach(option => {
                    const nestedOptions = _.get(option, "options")
                    if (_.get(nestedOptions, "length", 0) > 0) {
                      for (var j = 0; j < nestedOptions.length; j++) {
                        const nestedOptionsList = []
                        _.get(nestedOptions[j], "options", []).forEach(
                          option => {
                            nestedOptionsList.push(option.id)
                          }
                        )
                        currentSelectedItem[
                          nestedOptions[j].id
                        ] = nestedOptionsList
                      }
                    }
                    for (var i = 0; i < option.quantity; i++) {
                      options.push(option.id)
                    }
                  })
                  currentSelectedItem[optionList.id] = options
                  Object.assign(itemOptionList, currentSelectedItem)
                })
              }
              addSelectedItemOptions(itemOptionList)
              toggleAddToCartItem(
                true,
                {
                  ...itemSelected,
                  quantity: item.quantity,
                  instructions: item.instructions,
                  item_key: item.item_key,
                },
                true
              )
            }
          }}
        >{`${name}  x${quantity}`}</Text>
        <br />
        <Text className="item-price">$ {price}</Text>
        {props.isMyItem
          ? options &&
            options.map(option => {
              return option.options.map(item => {
                return (
                  <div className="item-instructions">{`${item.name} x${item.quantity}`}</div>
                )
              })
            })
          : null}
        {props.isMyItem ? (
          <div className="item-instructions">{item.instructions}</div>
        ) : null}
      </div>

      <section className="actions">
        {isPartner ? (
          // shamelessly opening one modal on top of a popup, sad.
          <Button
            className="suggest-item-btn"
            onClick={onAddToMyCart}
            disabled={itemLoading}
          >
            {itemLoading ? <LoadingOutlined /> : <PlusOutlined />}
            {ADD_TO_MY_CART}
          </Button>
        ) : (
          <React.Fragment>
            {
              <Button
                className={"suggest-item-btn"}
                onClick={onSuggestClick}
                disabled={
                  itemInMySuggestions || itemInPartnersCart || partnerAway
                }
              >
                {getItemState() || suggestText} <RightArrowBend />
              </Button>
            }
            <Button className={"remove-item-btn"} onClick={onRemoveItem}>
              <CloseOutlined />
            </Button>
          </React.Fragment>
        )}
      </section>
    </li>
  )
}

// each item in cart view, which are suggested you
export const SuggestedItemRow = props => {
  const {
    isPartner,
    onAddItemToCart,
    item,
    partner,
    user,
    suggestionState,
  } = props
  const name = _.get(item, "name", "")
  const price = _.get(item, "price", 0)

  const { dateState, partnerState } = React.useContext(FirebaseContext)

  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const onSuccess = () => {
    FirebaseService.write(
      true,
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${
        FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
      }`
    )
  }
  const onAcceptSuggestion = async () => {
    const payload = {
      item,
      [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: SUGGESTION_STATES.ACCEPTED,
    }

    // update in user's suggestedToPartner key.
    await FirebaseService.patch(
      { [item.id]: payload },
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${
        FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER
      }`
    )
    // set notification indicator for partner
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.INDICATOR]: true,
        [FIREBASE_STATE_KEYS.MESSAGE]: MENU_SUGGESTION_ACCEPTED,
        [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
      },
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${
        FIREBASE_STATE_KEYS.CART_NOTIFICATION
      }`
    )
    onAddItemToCart()
    const suggestedValue = {
      suggestedBy: partner.username,
      suggestedTo: user.username,
      type: "menu",
      id: acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      menu: item.name,
      isAccepted: true,
      partner1Location: _.get(partner.address, "user_address"),
      partner2Location: _.get(user.address, "user_address"),
      date: new Date(),
    }
    props.saveSuggestionEvent(suggestedValue)
  }
  const onRejectSuggestion = async () => {
    const partnerSuggestionPath = `${partner.uuid}/${FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER}/${item.id}/${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
    const partnerCartNotificationPath = `${partner.uuid}/${FIREBASE_STATE_KEYS.CART_NOTIFICATION}`
    // update in user's suggestedToPartner key.
    await FirebaseService.patch(
      {
        [partnerSuggestionPath]: SUGGESTION_STATES.REJECTED,
        [partnerCartNotificationPath]: {
          [FIREBASE_STATE_KEYS.INDICATOR]: true,
          [FIREBASE_STATE_KEYS.MESSAGE]: MENU_SUGGESTION_DECLINED,
          [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
        },
      },
      FirebaseService.getDefaultPath()
    )
    const suggestedValue = {
      suggestedBy: partner.username,
      suggestedTo: user.username,
      type: "menu",
      id: acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      menu: item.name,
      isAccepted: false,
      partner1Location: _.get(partner.address, "user_address"),
      partner2Location: _.get(user.address, "user_address"),
      date: new Date(),
    }
    props.saveSuggestionEvent(suggestedValue, onSuccess)
  }
  const partnerCart = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
    {}
  )
  const partnerCartItems = consolidateItemQuantityInCart(partnerCart.cart)
  const isItemInPartnersCart = item => {
    return (
      partnerCartItems.filter(partnerCartItem => partnerCartItem.id === item.id)
        .length > 0
    )
  }

  if (isPartner) {
    return (
      <li className="suggested-item-row">
        <div class="suggested-item-dataSection">
          <Text textType="smallTextPrimary" className="item-name">
            {name}
          </Text>
          <br />
          <Text className="item-price">$ {price}</Text>
        </div>
        <section className="status">
          <span className="suggestion-status">
            <SuggestionState
              suggestion={props}
              isItemInPartnersCart={item && isItemInPartnersCart(item)}
            />
          </span>
        </section>
      </li>
    )
  }
  return suggestionState === SUGGESTION_STATES.PENDING ? (
    <li className="suggested-item-row">
      <div class="suggested-item-dataSection">
        <Text textType="smallTextPrimary" className="item-name">
          {name}
        </Text>
        <br />
        <Text className="item-price">$ {price}</Text>
      </div>
      <section className="actions">
        <Button
          className="accept-suggestion-btn"
          onClick={onAddItemToCart}
          btnType="secondary"
        >
          {ACCEPT_SUGGESTION} <LikeFilled />
        </Button>
        <Button
          className="decline-suggestion-btn"
          onClick={onRejectSuggestion}
          btnType="secondary"
        >
          <DislikeFilled />
        </Button>
      </section>
    </li>
  ) : null
}

export const SuggestionState = props => {
  const { suggestion, isItemInPartnersCart } = props

  if (suggestion) {
    const suggestionState = suggestion[FIREBASE_STATE_KEYS.SUGGESTION_STATE]
    const isAccepted = suggestionState === SUGGESTION_STATES.ACCEPTED
    const isPending = suggestionState === SUGGESTION_STATES.PENDING
    const renderAccepted = (
      <React.Fragment>
        <Text textType="smallTextPrimary" className="state-label">
          {ACCEPTED_STATUS}
        </Text>
        <Text textType="smallTextPrimary" className="state-icon accepted">
          <LikeFilled />
        </Text>
      </React.Fragment>
    )
    if (isPending) {
      return (
        <React.Fragment>
          <Text textType="smallTextPrimary" className="state-label">
            {PENDING_STATUS}
          </Text>
          <Text textType="smallTextPrimary" className="state-icon pending">
            <ClockCircleOutlined />
          </Text>
        </React.Fragment>
      )
    } else if (!isPending && isItemInPartnersCart) {
      return renderAccepted
    } else if (
      suggestionState === SUGGESTION_STATES.REJECTED ||
      (isAccepted && !isItemInPartnersCart)
    ) {
      return (
        <React.Fragment>
          <Text textType="smallTextPrimary" className="state-label">
            {REJECTED_STATUS}
          </Text>
          <Text textType="smallTextPrimary" className="state-icon rejected">
            <DislikeFilled />
          </Text>
        </React.Fragment>
      )
    } else if (isAccepted) {
      return renderAccepted
    }
  }
  return null
}

const getSuggestionStateLabel = suggestionState => {
  if (suggestionState === SUGGESTION_STATES.PENDING) {
    return PENDING_STATUS
  } else if (suggestionState === SUGGESTION_STATES.REJECTED) {
    return REJECTED_STATUS
  } else {
    return ACCEPTED_STATUS
  }
}

export const EmptyCartHandler = props => {
  if (_.isEmpty(props.items)) {
    return (
      <section className="empty-cart">
        <img src={plates} class="img_plates" />
        <img src={hand} class="img_hand" />
        <Text textType="sectionTextPrimary" className="empty-cart-info">
          {EMPTY_CART_TEXT}
        </Text>
      </section>
    )
  }
  return props.children
}

export const CheckoutButton = props => {
  const {
    userReadyForCheckout,
    partnerName,
    onClickReadyForCheckout,
    isMinimumRemaining,
    onNotReadyForCheckout,
    deliveryMinimum,
    min_order_text,
  } = props

  const { partnerState } = React.useContext(FirebaseContext)
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  const showPartnerAway = isPartnerAway(partnerScreen, partnerOnline)
  const partnerGender = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender")
  )

  return userReadyForCheckout ? (
    <div className="checkout-ready-status">
      <div className="ready-for-checkout">
        <Text className="not-ready-checkout">{READY_TO_CHECKOUT}</Text>
        <Button
          className="not-ready-checkout-btn"
          onClick={onNotReadyForCheckout}
        >
          {UNDO}
        </Button>
      </div>
      <Text className="checkout-waiting-popup">
        {WAITING_TO_CHECKOUT(partnerName, partnerGender)}
      </Text>
    </div>
  ) : (
    <React.Fragment>
      <Button
        className="checkout-ready-btn"
        onClick={onClickReadyForCheckout}
        btnSize={"large"}
        btnType="primary"
        disabled={userReadyForCheckout || isMinimumRemaining || showPartnerAway}
      >
        {CHECKOUT_TEXT}
      </Button>
      <div className="minimum-order">
        {DELIVERY_MINIMUM(deliveryMinimum)}
        <Tooltip
          className="delvieryinfo"
          title={min_order_text}
          placement="top"
        >
          <div>
            <div className="delvieryinfo-circle">?</div>
          </div>
        </Tooltip>
      </div>
    </React.Fragment>
  )
}
